import styled from '@emotion/styled'

import { Markdown } from '@core/components/Markdown'

export const PrivacyAlertContainer = styled.div<{ hasContainer: boolean }>`
  width: 100%;
  padding: ${(props) =>
    props.hasContainer ? 'var(--spacing-8)' : '32px 50px 0px 50px'};
  background: ${(props) =>
    props.hasContainer ? 'var(--gray-2)' : 'transparent'};
  border-radius: 4px;
  color: ${(props) => (props.hasContainer ? 'var(--gray-8)' : 'var(--gray-3)')};
  font-size: var(--font-size-xs);
  ${(props) =>
    props.hasContainer ? 'box-shadow: var(--box-shadow-subtle);' : ''}

  a {
    color: ${(props) =>
      props.hasContainer ? 'var(--gray-8)' : 'var(--gray-3)'};
    text-decoration: underline;
  }
`

export const StyledMarkdown = styled(Markdown)`
  p {
    margin-top: 0;
  }
`
